import { useState, useEffect, CSSProperties } from 'react';
import { isClientSide } from '../../lib/isClientSide';
import { useWindowSize } from '../useWindowSize';
import { getLargestFitScale } from './getLargestFitScale';
import { getNodeInnerHeight } from './getNodeInnerHeight';

const getScale = (node: HTMLElement | null, container: HTMLElement | null) => {
  if (!isClientSide) return 0;

  if (!node || !container) return 0;

  const containerHeight = getNodeInnerHeight(container) || 1;

  return getLargestFitScale(node, containerHeight);
};

export const useAutoScale = ({
  container,
  node,
  skip
}: {
  container: HTMLElement | null;
  node: HTMLElement | null;
  skip?: boolean;
}): CSSProperties => {
  const [scale, setScale] = useState(0);
  const [size, setSize] = useState({
    width: 0,
    measure: '%'
  });

  const windowSize = useWindowSize();

  useEffect(
    () => setScale(container && node && !skip ? getScale(node, container) : 0),
    [windowSize.width, setScale, container, node, skip]
  );

  useEffect(() => {
    if (node && !skip) {
      const [width, measure] = node?.style.width.match(/[\d\\.]+|\D+/g) || [];

      if (width && measure) {
        setSize({
          width: Number(width),
          measure
        });
      }
    }
  }, [node, skip]);

  if (skip) return {};

  return scale === 0
    ? { visibility: 'hidden' }
    : {
        transform: `scale(${scale})`,
        width: `${size.width / scale}${size.measure}`
      };
};
